const PageStepsEN = {
  PageSteps: {
    'PAGE-MESSAGE': "In case you don't have one,",
    'PAGE-MESSAGE-2': ' to create!',
    'TEXT-SELECT-BOLD': 'You need a page for your business!',
    TEXT: "We've found that you don't have a page yet.",
    TEXT_BOLD: "Let's create one?",
    BUTTON: 'Create page',
    TEXT_2: 'We found out that you already have a page!',
    TEXT_BOLD_2: 'Confirm the page you want to use or bind a new one:',
    BUTTON_NEXT: 'Next',
    ERROR_ZIP: 'Invalid ZIP',
    ERROR_PHONE: 'Invalid phone number',
    ERROR_CITY: 'Invalid city or region',
    'BUTTON-BIND': 'Bind page',
    'TEXT-CREATE-PAGE': 'After creating your page we need to bind it!',
    'DESCRIPTION-CREATE-PAGE': 'Bind your page and give us the necessary permissions.',
    'PERMISSION-ERROR': 'We need the permissions to continue. Please select the page again!',
    'CLICK-HERE': ' click here',
  },
};

const PageStepsPT = {
  PageSteps: {
    'PAGE-MESSAGE': 'Caso não possua uma,',
    'PAGE-MESSAGE-2': ' para criar!',
    'TEXT-SELECT-BOLD': 'Você precisa de uma página para o seu negócio! Vincule agora.',
    TEXT: 'Verificamos que você não possui página ainda.',
    TEXT_BOLD: 'Vamos criar uma?',
    BUTTON: 'Criar página',
    TEXT_2: 'Confirme a página que deseja utilizar ou vincule uma nova:',
    TEXT_BOLD_2: 'Você pode escolhê-la abaixo ou criar uma nova:',
    BUTTON_NEXT: 'Próximo',
    ERROR_ZIP: 'CEP inválido',
    ERROR_PHONE: 'Número de telefone inválido',
    ERROR_CITY: 'Cidade ou estado inválido',
    'BUTTON-BIND': 'Vincular página',
    'TEXT-CREATE-PAGE': 'Depois de criar sua página precisamos vincula-la!',
    'DESCRIPTION-CREATE-PAGE': 'Vincule sua página e nos dê as permissões necessárias.',
    'PERMISSION-ERROR': 'Para continuarmos precisamos das permissões. Por favor selecione a página novamente!',
    'CLICK-HERE': ' clique aqui',
  },
};

export { PageStepsPT, PageStepsEN };
